import EmptyState from "@/components/empty-state";
import { Card, CardContent } from "@/components/ui/card";
import { useCurrentEnrollment } from "@/hooks/current-enrollment.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { StatusUp } from "iconsax-react";
import { useAtomValue } from "jotai";
import { FC, HTMLAttributes } from "react";

type WaitingApplicationApprovalProps = HTMLAttributes<HTMLDivElement>;

const WaitingApplicationApproval: FC<WaitingApplicationApprovalProps> = (
  props,
) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { currentApplication } = useCurrentEnrollment(editionId);

  return (
    <>
      {currentApplication?.status === "TO_REVIEW" && (
        <Card {...props}>
          <CardContent className="py-12">
            <EmptyState
              className="mx-auto"
              icon={StatusUp}
              message="Tu inscripción aún está pendiente de aprobación."
            >
              <strong className="block">
                Te notificaremos cuando tu empresa esté habilitada.
              </strong>
            </EmptyState>
          </CardContent>
        </Card>
      )}

      {currentApplication?.status === "REJECTED" && (
        <Card {...props}>
          <CardContent className="py-12">
            <EmptyState
              className="mx-auto"
              message="Lo sentimos, esta edición no está disponible para tu empresa en este momento. Para más información, contacta a Perú Sostenible."
            />
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default WaitingApplicationApproval;
